module.exports = __webpack_public_path__ + "img/carshina22_01.0a104196.jpg";